import { BeelineResult } from '../beelineLp/BeelineLanding';

export default function Beeline3Failed() {
  return <BeelineResult lpKey="beeline3" outcome="failed" variant={3} />;
}
